import { z } from "zod";
export const zslAssetTypeSchema = z.enum(["zap", "interface", "table"]);
export type zslAssetType = z.infer<typeof zslAssetTypeSchema>;
